/**
 * Wahler-Backend
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec, HttpContext 
        }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

// @ts-ignore
import { EvaluationSubCriteriaAttributeResponse } from '../model/evaluationSubCriteriaAttributeResponse';
// @ts-ignore
import { UpsertEvaluationSubCriteriaAttributeRequest } from '../model/upsertEvaluationSubCriteriaAttributeRequest';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';
import {
    EvaluationSubCriteriaAttributeControllerServiceInterface,
    GetEvaluationSubCriteriaAttributeBySubCriteriaRequestParams,
    UpsertRfiEvaluationSubCriteriaAttributeRequestParams,
    UpsertRfpEvaluationSubCriteriaAttributeRequestParams
} from './evaluationSubCriteriaAttributeController.serviceInterface';



@Injectable({
  providedIn: 'root'
})
export class EvaluationSubCriteriaAttributeControllerService extends BaseService implements EvaluationSubCriteriaAttributeControllerServiceInterface {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getEvaluationSubCriteriaAttributeBySubCriteria(requestParameters: GetEvaluationSubCriteriaAttributeBySubCriteriaRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<EvaluationSubCriteriaAttributeResponse>;
    public getEvaluationSubCriteriaAttributeBySubCriteria(requestParameters: GetEvaluationSubCriteriaAttributeBySubCriteriaRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<EvaluationSubCriteriaAttributeResponse>>;
    public getEvaluationSubCriteriaAttributeBySubCriteria(requestParameters: GetEvaluationSubCriteriaAttributeBySubCriteriaRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<EvaluationSubCriteriaAttributeResponse>>;
    public getEvaluationSubCriteriaAttributeBySubCriteria(requestParameters: GetEvaluationSubCriteriaAttributeBySubCriteriaRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const projectId = requestParameters?.projectId;
        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling getEvaluationSubCriteriaAttributeBySubCriteria.');
        }
        const evaluationCriteriaId = requestParameters?.evaluationCriteriaId;
        if (evaluationCriteriaId === null || evaluationCriteriaId === undefined) {
            throw new Error('Required parameter evaluationCriteriaId was null or undefined when calling getEvaluationSubCriteriaAttributeBySubCriteria.');
        }
        const subCriteriaId = requestParameters?.subCriteriaId;
        if (subCriteriaId === null || subCriteriaId === undefined) {
            throw new Error('Required parameter subCriteriaId was null or undefined when calling getEvaluationSubCriteriaAttributeBySubCriteria.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/projects/${this.configuration.encodeParam({name: "projectId", value: projectId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/evaluation-criteria/${this.configuration.encodeParam({name: "evaluationCriteriaId", value: evaluationCriteriaId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/subcriteria/${this.configuration.encodeParam({name: "subCriteriaId", value: subCriteriaId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/attributes`;
        return this.httpClient.request<EvaluationSubCriteriaAttributeResponse>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public upsertRfiEvaluationSubCriteriaAttribute(requestParameters: UpsertRfiEvaluationSubCriteriaAttributeRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<EvaluationSubCriteriaAttributeResponse>;
    public upsertRfiEvaluationSubCriteriaAttribute(requestParameters: UpsertRfiEvaluationSubCriteriaAttributeRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<EvaluationSubCriteriaAttributeResponse>>;
    public upsertRfiEvaluationSubCriteriaAttribute(requestParameters: UpsertRfiEvaluationSubCriteriaAttributeRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<EvaluationSubCriteriaAttributeResponse>>;
    public upsertRfiEvaluationSubCriteriaAttribute(requestParameters: UpsertRfiEvaluationSubCriteriaAttributeRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const projectId = requestParameters?.projectId;
        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling upsertRfiEvaluationSubCriteriaAttribute.');
        }
        const evaluationCriteriaId = requestParameters?.evaluationCriteriaId;
        if (evaluationCriteriaId === null || evaluationCriteriaId === undefined) {
            throw new Error('Required parameter evaluationCriteriaId was null or undefined when calling upsertRfiEvaluationSubCriteriaAttribute.');
        }
        const subCriteriaId = requestParameters?.subCriteriaId;
        if (subCriteriaId === null || subCriteriaId === undefined) {
            throw new Error('Required parameter subCriteriaId was null or undefined when calling upsertRfiEvaluationSubCriteriaAttribute.');
        }
        const upsertEvaluationSubCriteriaAttributeRequest = requestParameters?.upsertEvaluationSubCriteriaAttributeRequest;
        if (upsertEvaluationSubCriteriaAttributeRequest === null || upsertEvaluationSubCriteriaAttributeRequest === undefined) {
            throw new Error('Required parameter upsertEvaluationSubCriteriaAttributeRequest was null or undefined when calling upsertRfiEvaluationSubCriteriaAttribute.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/projects/${this.configuration.encodeParam({name: "projectId", value: projectId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/evaluation-criteria/${this.configuration.encodeParam({name: "evaluationCriteriaId", value: evaluationCriteriaId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/subcriteria/${this.configuration.encodeParam({name: "subCriteriaId", value: subCriteriaId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/attributes/rfi`;
        return this.httpClient.request<EvaluationSubCriteriaAttributeResponse>('patch', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: upsertEvaluationSubCriteriaAttributeRequest,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public upsertRfpEvaluationSubCriteriaAttribute(requestParameters: UpsertRfpEvaluationSubCriteriaAttributeRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<EvaluationSubCriteriaAttributeResponse>;
    public upsertRfpEvaluationSubCriteriaAttribute(requestParameters: UpsertRfpEvaluationSubCriteriaAttributeRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<EvaluationSubCriteriaAttributeResponse>>;
    public upsertRfpEvaluationSubCriteriaAttribute(requestParameters: UpsertRfpEvaluationSubCriteriaAttributeRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<EvaluationSubCriteriaAttributeResponse>>;
    public upsertRfpEvaluationSubCriteriaAttribute(requestParameters: UpsertRfpEvaluationSubCriteriaAttributeRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const projectId = requestParameters?.projectId;
        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling upsertRfpEvaluationSubCriteriaAttribute.');
        }
        const evaluationCriteriaId = requestParameters?.evaluationCriteriaId;
        if (evaluationCriteriaId === null || evaluationCriteriaId === undefined) {
            throw new Error('Required parameter evaluationCriteriaId was null or undefined when calling upsertRfpEvaluationSubCriteriaAttribute.');
        }
        const subCriteriaId = requestParameters?.subCriteriaId;
        if (subCriteriaId === null || subCriteriaId === undefined) {
            throw new Error('Required parameter subCriteriaId was null or undefined when calling upsertRfpEvaluationSubCriteriaAttribute.');
        }
        const upsertEvaluationSubCriteriaAttributeRequest = requestParameters?.upsertEvaluationSubCriteriaAttributeRequest;
        if (upsertEvaluationSubCriteriaAttributeRequest === null || upsertEvaluationSubCriteriaAttributeRequest === undefined) {
            throw new Error('Required parameter upsertEvaluationSubCriteriaAttributeRequest was null or undefined when calling upsertRfpEvaluationSubCriteriaAttribute.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/projects/${this.configuration.encodeParam({name: "projectId", value: projectId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/evaluation-criteria/${this.configuration.encodeParam({name: "evaluationCriteriaId", value: evaluationCriteriaId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/subcriteria/${this.configuration.encodeParam({name: "subCriteriaId", value: subCriteriaId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/attributes/rfp`;
        return this.httpClient.request<EvaluationSubCriteriaAttributeResponse>('patch', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: upsertEvaluationSubCriteriaAttributeRequest,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

}
